import React, { PureComponent } from 'react';
import _ from 'lodash';
import ConfigurationFields from '../../../elements/configViews/ConfigurationFields';
import { CONNECTION_CATEGORY_NEXLA_MONITOR } from '../../../../constants/connectionCategories';
import UIUtils from '../../../../lib/UIUtils';

class NexlaMonitorSourceConfiguration extends PureComponent {
  render() {
    const { data, nmTemplates } = this.props;
    let templates = nmTemplates[CONNECTION_CATEGORY_NEXLA_MONITOR];
    let fieldsValues = _.get(data.source_config, 'uiconfig', {});
    let templateID = _.get(fieldsValues, 'template', '');
    let template = templateID
      ? _.filter(templates, (template) => template.id === templateID)[0]
      : {};
    let templateFields = _.get(template, 'fields', []);
    let fields = _.filter(templateFields, (field) =>
      UIUtils.shouldRenderField(field, fieldsValues),
    );
    fieldsValues = {
      ...fieldsValues,
      template: template.label,
    };

    if (fields) {
      //  add template field
      fields.unshift({
        name: 'template',
        display_name: 'Endpoint',
      });
    }

    return (
      <ConfigurationFields
        {...this.props}
        connectionCategory={CONNECTION_CATEGORY_NEXLA_MONITOR}
        config={fieldsValues}
        overrideFields={fields}
      />
    );
  }
}

export default NexlaMonitorSourceConfiguration;
